// Customers Groups Mutations

export const updateFullGroupsList = (state, payload) => {
  state.fullGroupsList = payload
}

export const updateGroupsList = (state, payload) => {
  state.groupsList = payload
}

export const fetchGroupInfo = (state, payload) => {
  state.groupInfo = payload
}
